import { registerLocaleData } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import zh from '@angular/common/locales/zh';
import { MatomoInjector, MatomoTracker } from 'ngx-matomo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'sfe-ui';

  constructor(
    private matomoInjector: MatomoInjector,
    private matomoTracker: MatomoTracker
  ) {
    this.matomoInjector.init(environment.matomoConfig.trackerUrl, environment.matomoConfig.siteId);
  }

  ngOnInit(): void {
    registerLocaleData(zh);
    this.matomoTracker.setUserId(`${localStorage.getItem('userSite')}-${localStorage.getItem('userName')}-${localStorage.getItem('userid')}`);
  }
}
